import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Radar } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        toast.success("Sesión iniciada");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        toast.error("No se pudo iniciar sesión con Google");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center">
        <div className="w-14 h-14 rounded-2xl bg-[#0055FF] text-white grid place-items-center mx-auto mb-4">
          <Radar className="w-7 h-7" />
        </div>
        <div className="font-heading font-extrabold text-xl">Autenticando...</div>
        <div className="text-sm text-neutral-500 mt-1">Un segundo, estamos preparando tu dashboard.</div>
      </div>
    </div>
  );
}
